// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var Cursors;
(function (Cursors) {
    Cursors["SizeNS"] = "ns-resize;";
    Cursors["Hand"] = "pointer";
    Cursors["SizeWE"] = "ew-resize";
    Cursors["SizeAll"] = "move";
    Cursors["Grab"] = "grab";
    Cursors["Grabbing"] = "grabbing";
    Cursors["HSplit"] = "row-resize";
    Cursors["VSplit"] = "col-resize";
    Cursors["Default"] = "default";
    Cursors["Cross"] = "crosshair";
    Cursors["eraserCursor"] = "url(\"assets/webdesktop/resources/tool_eraser.svg\") 3.5 4, auto";
    Cursors["No"] = "not-allowed";
    Cursors["NoMoveVert"] = "ns-resize";
    Cursors["buySellCursor"] = "url(\"assets/webdesktop/resources/buySellCursor.png\") 5 7, auto";
})(Cursors || (Cursors = {}));
